/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ args }) {
    switch (args.type) {
      case 'updateDialog': {
        if (typeof props.update === 'function') props.update()
        break
      }
      default: {
      }
    }
  }
}
